// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"ae1468e9","610":"cf7b728a","676":"ae1468e9","686":"d229b3e8","739":"cf7b728a"}[chunkId] + ".chunk.css";
};